import { Injectable, Injector } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, from } from 'rxjs';
import { ImportProductComponent } from './import-product.component';
import { ProductCaptureData } from '../model/interfaces/product-capture.interface';
import { createModalInjector } from '../../utils/create-modal-injector';

@Injectable({
  providedIn: 'root',
})
export class ImportProductModalService {
  constructor(private ngbModal: NgbModal, private injector: Injector) {}

  openModal(): Observable<any> {
    const modalRef = this.ngbModal.open(ImportProductComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
      injector: createModalInjector(
        {
          isEdit: false,
        },
        this.injector
      ),
    });

    return from(modalRef.result);
  }

  openUpdateModal(product: ProductCaptureData): Observable<any> {
    const modalRef = this.ngbModal.open(ImportProductComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
      injector: createModalInjector(
        {
          isEdit: true,
          product: product,
        },
        this.injector
      ),
    });

    return from(modalRef.result);
  }
}
